"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Menu = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Menu"));
var _IsAuthorized = require("cornerstone_ui_core/lib/components/IsAuthorized");
var _MenuMap = _interopRequireDefault(require("./MenuMap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// submenu keys of first level
const rootSubmenuKeys = [];
var _default = _ref => {
  let {
    menus,
    shortcutNavigationMenuOptions,
    ...rest
  } = _ref;
  const [menuList, updateMenuList] = (0, _react.useState)(menus);
  const [openKeys, setOpenKeys] = _react.default.useState([]);
  const getAuthorizedMenus = menus => {
    let authorizedMenus = [];
    menus && menus.forEach(menu => {
      let subMenus = [];
      if (menu.subCategoryVOList && menu.subCategoryVOList.length > 0) subMenus = getAuthorizedMenus(menu.subCategoryVOList);
      if ((menu.pathUrl || subMenus.length > 0) && !menu.functionKey || (0, _IsAuthorized.isEntitled)({
        user: rest.user,
        perform: menu.functionKey
      })) {
        authorizedMenus.push({
          path: menu.pathUrl,
          title: menu.menuCategory || menu.subCategory,
          accessFns: [menu.functionKey],
          menus: subMenus
        });
        authorizedMenus.sort((a, b) => a.title.localeCompare(b.title));
      }
    });
    return authorizedMenus;
  };
  (0, _react.useEffect)(() => {
    let modifiedMenus = [...menuList];
    shortcutNavigationMenuOptions && shortcutNavigationMenuOptions.forEach(s => {
      const authorizedMenus = getAuthorizedMenus(s.categoryVOList);
      if (modifiedMenus.find(m => m.title === s.option)) {
        modifiedMenus.find(m => m.title === s.option).menus = authorizedMenus;
      }

      // If First level menu list has sub menus, store keys in collection for checking open menu item
      modifiedMenus.forEach((x, index) => {
        if (x.menus && x.menus.length > 0 && rootSubmenuKeys.indexOf("item_" + index) === -1) {
          rootSubmenuKeys.push("item_" + index);
        }
      });
    });
    updateMenuList(modifiedMenus);
  }, [shortcutNavigationMenuOptions]);
  const onOpenChange = keys => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Menu.default, _extends({
    theme: "light",
    className: "side-menu",
    mode: "inline",
    openKeys: openKeys,
    onOpenChange: onOpenChange
  }, rest), (0, _MenuMap.default)({
    menus: menuList
  }));
};
exports.default = _default;